import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { switchMap, map, catchError } from 'rxjs/operators';
import * as SchedulerActions from '../actions/scheduler.actions'; // adjust path

import { Action } from '@ngrx/store';
import { SchedulerHttpService } from '../services';

@Injectable()
export class SchedulerEffect {

  // GET Scheduler
  getSchedulerEffect$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType<SchedulerActions.GetScheduler>(SchedulerActions.ActionTypes.GET_SCHEDULER),
      switchMap((action: SchedulerActions.GetScheduler) =>
        this.schedulerHttpService.getSchduler(action.companyId, action.storyId, action.payload).pipe(
          map((response) => {
            return new SchedulerActions.GetSchedulerSuccess(response);
          }),
          catchError((error: any) => {
            return of(new SchedulerActions.GetSchedulerFailure());
          })
        )
      )
    )
  );

  // CREATE Scheduler (POST)
  createSchedulerEffect$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType<SchedulerActions.CreateScheduler>(SchedulerActions.ActionTypes.CREATE_SCHEDULER),
      switchMap((action: SchedulerActions.CreateScheduler) =>
        this.schedulerHttpService.create(action.companyId, action.storyId, action.payload).pipe(
          map((response) => {
            return new SchedulerActions.CreateSchedulerSuccess();
          }),
          catchError((error: any) => {
            return of(new SchedulerActions.CreateSchedulerFailure());
          })
        )
      )
    )
  );

  // UPDATE Scheduler (PATCH)
  updateSchedulerEffect$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType<SchedulerActions.UpdateScheduler>(SchedulerActions.ActionTypes.UPDATE_SCHEDULER),
      switchMap((action: SchedulerActions.UpdateScheduler) =>
        this.schedulerHttpService.update(action.companyId, action.storyId, action.payload).pipe(
          map((response) => {
            return new SchedulerActions.UpdateSchedulerSuccess();
          }),
          catchError((error: any) => {
            return of(new SchedulerActions.UpdateSchedulerFailure());
          })
        )
      )
    )
  );

  // DELETE Scheduler
  deleteSchedulerEffect$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType<SchedulerActions.DeleteScheduler>(SchedulerActions.ActionTypes.DELETE_SCHEDULER),
      switchMap((action: SchedulerActions.DeleteScheduler) =>
        this.schedulerHttpService.deleteSchedule(action.companyId, action.storyId).pipe(
          map(() => {
            return new SchedulerActions.DeleteSchedulerSuccess();
          }),
          catchError((error: any) => {
            return of(new SchedulerActions.DeleteSchedulerFailure());
          })
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private schedulerHttpService: SchedulerHttpService
  ) {}
}
